<template>
  <!-- 用户列表 -->
  <div id="agentNoLogin">
    <div class="noLogin">
      <img src="../assets/images/agent_ds.png" alt="" />
      <div class="text">{{ $t("lanV4.noPermissions") }}</div>
    </div>
  </div>
</template>
        <script>
import commonMixin from "@/mixin/common/commonMixin";
export default {
  name: "agentNoLogin",
  mixins: [commonMixin],
  components: {},
  data() {
    return {};
  },
};
</script>
        
    <style lang="scss">
#agentNoLogin {
  background: #fff;
  height: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  .noLogin {
    .text {
      color: #909090;
      text-align: center;
      font-family: HarmonyOS-Medium;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      margin-top: 16px;
    }
  }
}
</style>
        